import React from "react";

import LogoWhite from "/ENRX-logo-white.svg";
import LogoBlack from "/ENRX-logo-black.svg";

const Logo = ({ logoWhite, logoBlack, pointerEvents = "auto" }) => {
  return (
    <img
      style={{
        width: "8vw",
        pointerEvents: pointerEvents,
      }}
      src={logoWhite ? LogoWhite : logoBlack ? LogoBlack : LogoWhite}
      alt="Logo"
    />
  );
};

export default Logo;
